export default {
    INVALID_EMAIL: 'Please enter a proper email',
};
